import React from "react";

const EmployerDashboard = () => {
  return (
    <div>
      <h1>This is Employer Dashboard</h1>
    </div>
  );
};

export default EmployerDashboard;
